export class Range {
  start: number;
  end: number;
}
